import { IColumns } from "@/components/generic/GenericTable";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";
import React from "react";
import { useEffect, useState } from "react";
interface IGenericTableLeft {
  rowData?: any[];
  columns?: any[];
  columnsMerge?: boolean;
  rowsMerge?: boolean;
  applyColour?: boolean;
}
export const GenericTableLeft = (props: IGenericTableLeft) => {
  const [tableData, setTableData] = useState<any>([]);
  const getCellClassName = (cellData: any): string => {
    if (typeof cellData === "number") {
      //return cellData >= 0 ? "positive-number number-cell" : "negative-number number-cell";
      return props?.applyColour === true
        ? cellData > 0
          ? "positive-number number-cell"
          : cellData < 0 && "negative-number number-cell"
        : "number-cell";
    } else {
      return "string-cell";
    }
  };

  useEffect(() => {
    setTableData(props?.rowData);
  }, [props?.rowData]);
  const onHandleScrollgen = (e: React.UIEvent<HTMLDivElement>) => {
    const container = document.getElementById("main-scroll-div");
    if (container) {
      container.scrollLeft = e.currentTarget.scrollLeft;
    }
  };
  return (
    <>
      <div
        className="table-container-generictableleft generic-id"
        // onScroll={handleScroll}
        onScroll={onHandleScrollgen}
        style={{ overflowX: "auto" }}
      >
        <table className="generictableleft-section">
          <tbody>
            {props?.columnsMerge
              ? getDataWithColumnsMerge(props, getCellClassName)
              : props.rowsMerge
                ? getDataWithRowsMerge(props, getCellClassName)
                : getDataWithoutRowsAndColumnsMerge(props, getCellClassName)}
          </tbody>
        </table>
      </div>
    </>
  );
};

const getDataWithoutRowsAndColumnsMerge = (
  props: IGenericTableLeft,
  getCellClassName: Function,
) => {
  {
    return (
      props?.columns &&
      props?.columns?.length > 0 &&
      props?.columns?.map((cell: IColumns, index: number) => {
        return (
          <tr>
            <td>{cell?.columnName}</td>
            {props?.rowData &&
              props?.rowData?.map((rowDataItem: any, colIndex: number) => (
                <td
                  key={colIndex}
                  className={getCellClassName(
                    rowDataItem ? rowDataItem[cell?.key] : 0,
                  )}
                >
                  {rowDataItem && (
                    <>
                      {typeof rowDataItem[cell?.key] === "function" ? (
                        rowDataItem[cell?.key]()
                      ) : (
                        <>
                          {rowDataItem[cell?.key]
                            ? cell?.tdCustomFunction
                              ? cell?.tdCustomFunction(rowDataItem[cell?.key])
                              : rowDataItem[cell?.key]
                            : "-"}
                        </>
                      )}
                    </>
                  )}
                </td>
              ))}
          </tr>
        );
      })
    );
  }
};
const getDataWithColumnsMerge = (
  props: IGenericTableLeft,
  getCellClassName: Function,
) => {
  {
    return (
      props?.columns &&
      props?.columns?.length > 0 &&
      props?.columns?.map((cell: IColumns, index: number) => {
        {
          return (
            <tr>
              <td>{cell?.columnName}</td>
              {props?.rowData &&
                props?.rowData?.map((rowDataItem: any, colIndex: number) => {
                  return index !== 0 ? (
                    <td
                      key={colIndex}
                      className={getCellClassName(
                        rowDataItem ? rowDataItem[cell?.key] : 0,
                      )}
                    >
                      {rowDataItem ? (
                        <>
                          {typeof rowDataItem[cell?.key] === "function" ? (
                            rowDataItem[cell?.key]()
                          ) : (
                            <>
                              {rowDataItem[cell?.key]
                                ? rowDataItem[cell?.key]
                                : "-"}
                            </>
                          )}
                        </>
                      ) : (
                        "NA"
                      )}
                    </td>
                  ) : (
                    colIndex === 0 && (
                      <td
                        key={colIndex}
                        className={`colspan-content-td-${
                          props?.rowData?.length
                        }  ${getCellClassName(
                          rowDataItem ? rowDataItem[cell?.key] : 0,
                        )}`}
                        colSpan={props?.rowData?.length}
                      >
                        {rowDataItem && (
                          <>
                            {typeof rowDataItem[cell?.key] === "function" ? (
                              rowDataItem[cell?.key]()
                            ) : (
                              <>
                                {rowDataItem[cell?.key]
                                  ? rowDataItem[cell?.key]
                                  : ""}
                              </>
                            )}
                          </>
                        )}
                      </td>
                    )
                  );
                })}
            </tr>
          );
        }
      })
    );
  }
};
const getDataWithRowsMerge = (
  props: IGenericTableLeft,
  getCellClassName: Function,
) => {
  const device = DeviceContext();
  return (
    <>
      {device && device.isMobile ? (
        <>
          {" "}
          {props?.rowData &&
            props?.rowData?.map((rowDataItem: any, rowIndex: number) => (
              <tr key={rowIndex} className="">
                {rowIndex === 0 && (
                  <td rowSpan={props?.rowData.length}>
                    {props?.columns[0].columnName}
                  </td>
                )}
                {rowDataItem.map((i: any, colIndex: number) => (
                  <td
                    key={colIndex}
                    className={`${getCellClassName(
                      colIndex,
                    )} rowsmerge-number-cell`}
                    style={{
                      backgroundColor: "white",
                      borderLeft: "2px solid white",
                    }}
                  >
                    {i}
                  </td>
                ))}
              </tr>
            ))}
        </>
      ) : (
        <>
          <tr>
            <td rowSpan={props?.rowData.length + 1}>
              {props?.columns[0].columnName}
            </td>
          </tr>
          {props?.rowData &&
            props?.rowData?.map((rowDataItem: any, colIndex: number) => (
              <>
                <tr className="merge-data-row">
                  {rowDataItem.map((i: any) => {
                    return (
                      <td
                        className={getCellClassName(0)}
                        style={{
                          backgroundColor: "white",
                          borderLeft: "2px solid white",
                        }}
                      >
                        {i}
                      </td>
                    );
                  })}
                </tr>
              </>
            ))}
        </>
      )}
      {/* <tr>
        <td>hello1</td>
        <td>hello2</td>
        <td>hello3</td>
      </tr>
      <tr>
        <td>hello4</td>
        <td>hello5</td>
        <td>hello6</td>
      </tr>
      <tr>
        <td>hello7</td>
        <td>hello8</td>
        <td>hello9</td>
      </tr> */}
    </>
  );
  return (
    props?.columns &&
    props?.columns?.length > 0 &&
    props?.columns?.map((cell: IColumns, index: number) => {
      {
        return (
          <tr>
            <td>{cell?.columnName}</td>
            {props?.rowData &&
              props?.rowData?.map((rowDataItem: any, colIndex: number) => (
                <td
                  key={colIndex}
                  className={getCellClassName(
                    rowDataItem ? rowDataItem[cell?.key] : 0,
                  )}
                >
                  {rowDataItem && (
                    <>
                      {typeof rowDataItem[cell?.key] === "function" ? (
                        rowDataItem[cell?.key]()
                      ) : (
                        <>
                          {rowDataItem[cell?.key]
                            ? rowDataItem[cell?.key]
                            : "-"}
                        </>
                      )}
                    </>
                  )}
                </td>
              ))}
          </tr>
        );
      }
    })
  );
};
